import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'myabvv-personal-information-address',
    templateUrl: './personal-information-address.component.html',
    styles: [],
    standalone: true,
    imports: [TranslateModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PersonalInformationAddressComponent implements OnInit {
  @Input() street: string;
  @Input() city: string;
  @Input() country: string;
  @Input() houseNumber: string;
  @Input() boxNumber: string;
  @Input() zipCode: string;

  constructor() { }

  ngOnInit() {
  }

}
